<div class="select-items-container">
    <h1 mat-dialog-title>{{ title }}</h1>
    <div mat-dialog-content>
        <p> {{ description }} </p>
        <form class="management-search-form search-form" [formGroup]="itemsForm">
            <mat-form-field *ngIf="searchKey" appearance="fill" class="search-field">
                <mat-label>{{ search }}</mat-label>
                <mat-placeholder>{{ search }}</mat-placeholder>
                <input #searchInput class="form-control" type="text" matInput formControlName="search" />
                <button matSuffix mat-icon-button aria-label="Search" type="submit">
                    <mat-icon>search</mat-icon>
                </button>
            </mat-form-field>
            <div class="select-all-wrapper">
                <mat-checkbox
                    *ngIf="selectAll"
                    formControlName="selectAll"
                    (change)="handleSelectAll"
                >
                    Select All
                </mat-checkbox>
            </div>
        </form>
        <three-dot-loader [isTopAligned]="true" *ngIf="isLoading; else documentList;"></three-dot-loader>
        <ng-template #documentList>
            <mat-selection-list (selectionChange)="onItemSelectionChange($event)">
                <mat-list-option
                    selected="{{ itemSelected(form) }}"
                    [disabled]="existingItem(form)"
                    *ngFor="let form of filteredAvailableItems; let i = index"
                    [ngClass]="{ 'even-row': i % 2 === 0, 'odd-row': i % 2 === 1 }"
                    [value]="form"
                >
                    <span [ngClass]="existingItem(form) ? 'existing-form' : ''">{{ form.displayName }}</span>
                </mat-list-option>
            </mat-selection-list>
        </ng-template>
    </div>
    <div *ngIf="!isLoading" class="form-footer" mat-dialog-actions>
        <button mat-button class="standard secondary" (click)="close()">Cancel</button>
        <button mat-button class="standard primary" (click)="addItems()">{{ btnText }}</button>
    </div>
</div>
